import { Award, GraduationCap } from "lucide-react";
import Reveal from "../Reveal";

const CERTIFICATIONS = [
  {
    title: "MCTS — Microsoft .NET 3.5 / ASP",
    detail: "Exams 70-562 & 70-536",
  },
  {
    title: "MCTS — Web Development",
    detail: "Exam 70-480: HTML5, JavaScript & CSS3",
  },
  {
    title: "CompTIA A+ / Network+",
    detail: "Hardware & networking fundamentals",
  },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative z-10 py-24 md:py-32 bg-[#f4f3ee] border-t border-black/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
          {/* Bio */}
          <div className="lg:col-span-7">
            <Reveal>
              <span className="font-mono-tech text-xs uppercase tracking-[0.25em] text-[#2f4bff]">
                / About
              </span>
              <h2 className="mt-5 font-head text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight leading-[1.02] text-[#111111]">
                Shawn Rye
              </h2>
              <p className="mt-3 font-mono-tech text-xs uppercase tracking-[0.18em] text-neutral-500">
                Senior Software Engineer / Architect · 13+ years
              </p>
              <div className="mt-8 space-y-6 font-body text-lg text-neutral-600 leading-relaxed max-w-2xl">
                <p>
                  I&apos;m a senior software engineer who designs, builds and
                  modernizes enterprise .NET applications. My specialty is taking
                  legacy systems — Web Forms, VB.NET and .NET Framework — and
                  bringing them into modern .NET Core, Blazor Server and Blazor
                  WebAssembly, backed by SQL Server, Azure and clean API design.
                </p>
                <p>
                  I&apos;ve led development for large corporations, government
                  and healthcare organizations, and I fold modern AI-assisted
                  engineering (GitHub Copilot with Claude, ChatGPT and Gemini)
                  into everyday work — shipping faster while keeping quality,
                  testing and judgment firmly in human hands.
                </p>
              </div>
            </Reveal>
          </div>

          {/* Credentials */}
          <div className="lg:col-span-5">
            <Reveal delay={0.1}>
              <div className="bg-white border border-black/10 p-8 md:p-10">
                <div className="flex items-center gap-3">
                  <Award className="h-5 w-5 text-[#2f4bff]" />
                  <h3 className="font-mono-tech text-xs uppercase tracking-[0.2em] text-neutral-700">
                    Certifications
                  </h3>
                </div>
                <ul className="mt-6 space-y-5">
                  {CERTIFICATIONS.map((c) => (
                    <li
                      key={c.title}
                      data-testid={`cert-${c.title
                        .toLowerCase()
                        .replace(/[^a-z0-9]+/g, "-")
                        .replace(/(^-|-$)/g, "")}`}
                      className="border-l-2 border-[#2f4bff] pl-4"
                    >
                      <p className="font-head text-lg font-semibold text-[#111111] leading-snug">
                        {c.title}
                      </p>
                      <p className="mt-1 font-body text-sm text-neutral-500">
                        {c.detail}
                      </p>
                    </li>
                  ))}
                </ul>

                <div className="mt-8 pt-8 border-t border-black/10">
                  <div className="flex items-center gap-3">
                    <GraduationCap className="h-5 w-5 text-[#2f4bff]" />
                    <h3 className="font-mono-tech text-xs uppercase tracking-[0.2em] text-neutral-700">
                      Education
                    </h3>
                  </div>
                  <p className="mt-5 font-head text-lg font-semibold text-[#111111]">
                    MCSE Coursework
                  </p>
                  <p className="mt-1 font-body text-sm text-neutral-500">
                    Hesser College, Manchester, NH
                  </p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
